import EditJsonTable from './edit-json-table'
EditJsonTable.install = function (Vue) {
  Vue.component(EditJsonTable.name, EditJsonTable)
}
export default EditJsonTable
